<template>
  <div>
    <select
      :id="id"
      ref="select"
      :multiple="multiple"
      :disabled="disabled"
      @change.prevent="onChange"
    >
      <slot></slot>
    </select>
    <label ref="label" :for="id">{{ label }}</label>
  </div>
</template>

<script>
import FormSetup from '@common/Mixins/FormSetup';
export default {
  emits: ['update:modelValue'],
  mixins: [FormSetup],
  inheritAttrs: false,
  props: {
    modelValue: {
      default: null
    },
    id: {
      type: String
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$_FormSetup_setupForm();
  },
  methods: {
    selectedOptions(ref) {
      const values = [];
      const selectedOptions = ref.selectedOptions;
      for (let i = 0; i < selectedOptions.length; i++) {
        values.push(selectedOptions[i].value);
      }
      return values;
    },
    onChange(event) {
      this.touched = true;
      let value;

      if (this.multiple) {
        value = this.selectedOptions(event.target);
      } else {
        value = event.target.value;
      }

      this.$emit('update:modelValue', value);
    }
  }
};
</script>

<style lang="scss"></style>
